import React from "react";

import "./sign-in-sign-up.styles.scss";
import SignIn from "../../components/sign-in/sign-in.component";
import SignUp from "../../components/sign-up/sign-up.component";

const SignInAndSignUpPage = (props) => (
  <div className="sign-in-sign-up">
    <SignIn />
    <div className="divider"></div>
    <SignUp />
  </div>
);

export default SignInAndSignUpPage;
